<!-- Group outing -->
<div
  id="group-outing"
  class="flex flex-col justify-start w-full h-full box-white box-responsive">
  <div class="box-header-center md:box-header">
    <h3 class="font-bold">Enhance your group outing</h3>
  </div>
  <div
    class="w-full box-body grid grid-flow-row-dense lg:grid-cols-2 grid-cols-1">
    <!-- Upsells -->
    @for (upsell of transaction().transaction.event?.upsells; track upsell.id) {
      <div class="flex">
        <label
          for="{{ upsell.id }}"
          class="package-card relative overflow-hidden flex w-full md:w-auto"
          [ngClass]="{
            checked:
              upsellSelected !== null && upsell.id === upsellSelected()?.id,
          }">
          <div class="top-0 left-0 absolute opacity-10 w-full h-full">
            <img
              [ngSrc]="upsell.urlImage"
              class="w-full h-full object-center object-cover"
              width="320"
              height="110"
              [priority]="true"
              alt="" />
          </div>
          <div class="flex package-radio">
            <input
              type="checkbox"
              class="btn-radio"
              #radioButton
              name="{{ upsell.id }}"
              id="{{ upsell.id }}"
              [value]="upsell.buyerTypeId"
              (change)="onChangeUpsell(radioButton)"
              [checked]="
                upsellSelected !== null && upsell.id === upsellSelected()?.id
              " />
          </div>
          <div class="w-full">
            <div class="package-header">
              <h5 class="mr-2 font-bold">{{ upsell.name }}</h5>
              <div>
                <p class="min-w-max font-bold">
                  + ${{ upsell.price | number: '1.2-2' }}
                </p>
                <h6 class="font-bold text-right">Per ticket</h6>
              </div>
            </div>
            <div class="package-body">
              <p>{{ upsell.description }}</p>
            </div>
          </div>
        </label>
      </div>
    }
  </div>
  @if (upsellSelected()) {
    <div class="justify-end items-center flex border-t border-t-gray-100 p-5">
      <h5 class="font-bold text-main">
        Extra Cost (${{ upsellSelected()?.price | number: '1.2-2' }} x
        {{ totalTransactionSeats() }} Seats): ${{
          (upsellSelected()?.price || 0) * totalTransactionSeats()
            | number: '1.2-2'
        }}
      </h5>
    </div>
  }
</div>
